<div id="verify-phone-number" fxLayout="column" linPerfectScrollbar>
  <div id="verify-phone-number-form-wrapper" fxLayout="column" fxLayoutAlign="center center">
    <div id="verify-phone-number-form">
      <div class="logo">
        <img [src]="(platformSettings$ | async)?.logoUrl" />
      </div>

      <div class="title">{{ 'VERIFY_PHONE_NUMBER.TITLE_TEXT' | translate }}</div>
      <div class="description">{{ 'VERIFY_PHONE_NUMBER.DESCRIPTION' | translate }}</div>

      @if (formError) {
      <div class="lin-form-error">{{ formError }}</div>
      }

      <form name="form" [formGroup]="form" (ngSubmit)="verifyPhoneNumber()" novalidate>
        <mat-form-field>
          <input type="tel" matInput placeholder="{{ 'FIELDS.PHONE_NUMBER' | translate }}" maxlength="20" formControlName="phone" />

          @if (this.form.get('phone').hasError('phoneNumber')) {
          <mat-error> {{ 'VERIFY_PHONE_NUMBER.VALID_PHONE' | translate }} </mat-error>
          } @else {
          <mat-error>
            <lin-form-field-error></lin-form-field-error>
          </mat-error>
          }
        </mat-form-field>

        <mat-form-field>
          <input
            matInput
            #verifyCode
            placeholder="{{ 'FIELDS.VERIFICATION_CODE' | translate }}"
            maxlength="20"
            formControlName="verificationCode"
          />
          <mat-error>
            <lin-form-field-error></lin-form-field-error>
          </mat-error>
        </mat-form-field>

        <div class="form-footer" fxLayout="column" fxLayoutAlign="center">
          <button
            class="submit-button"
            mat-raised-button=""
            type="button"
            color="primary"
            fxLayoutAlign="center center"
            [disabled]="!this.form.get('phone').valid"
            (click)="sendSms()"
          >
            @if (isLoading) {
            <mat-progress-spinner [diameter]="26" [strokeWidth]="2" mode="indeterminate" color="accent"></mat-progress-spinner>
            } @else {
            <span>{{ 'VERIFY_PHONE_NUMBER.BUTTON.SEND_SMS' | translate }}</span>
            }
          </button>

          <lin-form-submit-button [isLoading]="isSubmitting" [isDisabled]="!smsSend">
            <span>{{ 'VERIFY_PHONE_NUMBER.BUTTON.CONFIRM' | translate }}</span>
          </lin-form-submit-button>
        </div>
      </form>
    </div>
  </div>
</div>
